import { render, staticRenderFns } from "./ProfileBubble.vue?vue&type=template&id=6e79316b"
import script from "./ProfileBubble.vue?vue&type=script&lang=js"
export * from "./ProfileBubble.vue?vue&type=script&lang=js"
import style0 from "./ProfileBubble.vue?vue&type=style&index=0&id=6e79316b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports